import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllPartnerAgencyUsers.graphql';
import { Query, QueryallPartnerAgencyUsersArgs } from '../../__generated__/globalTypes';

export const useAllPartnerAgencyUsersQuery = (options?: QueryHookOptions<Query, QueryallPartnerAgencyUsersArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallPartnerAgencyUsersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllPartnerAgencyUsersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallPartnerAgencyUsersArgs>
): QueryResult<Query, QueryallPartnerAgencyUsersArgs> & {
  getAllPartnerAgencyUsers: LazyQueryExecFunction<Query, QueryallPartnerAgencyUsersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllPartnerAgencyUsers, result] = useLazyQuery<Query, QueryallPartnerAgencyUsersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllPartnerAgencyUsers, ...result };
};

export const useAllPartnerAgencyUsersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllPartnerAgencyUsers = useCallback(
    (options?: Omit<QueryOptions<QueryallPartnerAgencyUsersArgs, Query>, 'query'>) =>
      client.query<Query, QueryallPartnerAgencyUsersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllPartnerAgencyUsers };
};
// Suspense Query Hooks
export const useAllPartnerAgencyUsersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallPartnerAgencyUsersArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallPartnerAgencyUsersArgs>(QUERY, {
    ...options
  });

  return result;
};
